import { render, staticRenderFns } from "./complaintReply.vue?vue&type=template&id=32fdced0&scoped=true&"
import script from "./complaintReply.vue?vue&type=script&lang=js&"
export * from "./complaintReply.vue?vue&type=script&lang=js&"
import style0 from "./complaintReply.vue?vue&type=style&index=0&id=32fdced0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fdced0",
  null
  
)

export default component.exports